import React from 'react';
import { useTranslation } from 'react-i18next';
import Loader from 'components/Loader';
import { Button } from '@smiles/voebiz-ui-kit';
import LampIcon from '../Icons/LampIcon';

interface Props {
  toggleConfirmationModal(): void;
  // filename: string;
  sendCSVFileAndCampaingName(): void;
  isLoading: boolean;
}

const ConfirmationModalBatch: React.FC<Props> = ({
  toggleConfirmationModal,
  sendCSVFileAndCampaingName,
  isLoading,
}) => {
  const { t } = useTranslation(['includeTeam']);

  const handleSendFile = () => {
    sendCSVFileAndCampaingName();
  };

  return (
    <div className="success-wrapper" data-testid="success-many-modal">
      <div className="icon-wrapper">
        <LampIcon />
      </div>
      <span className="title-success">{t('includeTeam:file_confirmation_title')}</span>
      <span className="subtitle">{t('includeTeam:file_confirmation_text')}</span>
      <div className="btn-wrapper-confirmation">
        <button type="button" className="back-text-btn" onClick={toggleConfirmationModal}>
          Voltar
        </button>
        <Button className="ok-button" onClick={handleSendFile} disabled={isLoading}>
          {isLoading ? <Loader small /> : 'Confirmar envio'}
        </Button>
      </div>
    </div>
  );
};

export default ConfirmationModalBatch;
